import { createSlice } from "@reduxjs/toolkit";
import { getAllMaterialAPI } from "../../services/getAllMaterial";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getAllMaterialSlice = createSlice({
  name: "getAllMaterial",
  initialState: data,
  reducers: {
    getAllMaterialInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getAllMaterialInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
      state.error = "";
    },
    getAllMaterialInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getAllMaterialInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getAllMaterialHandler = (payload) => async (dispatch) => {
  try {
    dispatch(getAllMaterialAction.getAllMaterialInfo());
    const response = await getAllMaterialAPI(payload);
    dispatch(getAllMaterialAction.getAllMaterialInfoSuccess(response));
  } catch (e) {
    dispatch(
      getAllMaterialAction.getAllMaterialInfoFailure(
        e?.response?.data?.message || e?.message
      )
    );
  }
};

export default getAllMaterialSlice.reducer;
export const getAllMaterialAction = getAllMaterialSlice.actions;
